import { render, staticRenderFns } from "./PaymentReceiptTable.vue?vue&type=template&id=0641b820&scoped=true&"
import script from "./PaymentReceiptTable.vue?vue&type=script&lang=js&"
export * from "./PaymentReceiptTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/table.css?vue&type=style&index=0&id=0641b820&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641b820",
  null
  
)

export default component.exports